var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"allData"},_vm._l((_vm.listData),function(item,id){return _c('ul',{key:`trans_${id + _vm.startIndex}`,class:{selected: id + _vm.startIndex === _vm.currentIndex },on:{"click":function($event){return _vm.transViewClick(id)}}},[_c('li',[_vm._v(_vm._s(item.dates))]),_c('li',{class:Number(item.prices) > Number(_vm.selectItem.clearPrice)
              ? 'sellDirection'
              : Number(item.prices) < Number(_vm.selectItem.clearPrice)
                ? 'buyDirection'
                : ''},[_vm._v(" "+_vm._s(Number(item.prices).toFixed(_vm.selectItem.coinDigitalNum))+" ")]),_c('li',{class:_vm.setStrClass(
              item.upDown,
              '买入',
              'sellDirection',
              'buyDirection'
            )},[_vm._v(" "+_vm._s(Number(item.volumn).toFixed(_vm.selectItem.quantityNum))+" "+_vm._s(item.upDown === '买入' ? '↑' : '↓')+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }